import { contrastRatio, highestContrastColor } from '../../../utils/dom/color-contrast';

export default class FixDisclaimer {
	static DISCLAIMER_LINK_SELECTOR = '#form-disclaimer-trigger';
	static DISCLAIMER_TEXT_SELECTOR = '#fl-disclaimer';
	static ARIA_EXPANDED_ATTRIBUTE = 'aria-expanded';
	static ARIA_HIDDEN_ATTRIBUTE = 'aria-hidden';

	start() {
		if ($('.ENABLE_FIX_DISCLAIMER_ACCESSIBILITY').length === 0) {
			return;
		}
		this.fixDisclaimer();
		this.fixDisclaimerLinks();
	}

	fixDisclaimer() {
		$(document).on('nfFormReady  aiEnhancedFormUpdate', () => {
			const disclaimerLink = $(FixDisclaimer.DISCLAIMER_LINK_SELECTOR);
			const disclaimerText = $(FixDisclaimer.DISCLAIMER_TEXT_SELECTOR);
			disclaimerLink.removeAttr('title');
			disclaimerLink.attr(FixDisclaimer.ARIA_EXPANDED_ATTRIBUTE, 'false');
			disclaimerText.attr(FixDisclaimer.ARIA_HIDDEN_ATTRIBUTE, 'true');
			disclaimerLink.on('click', () => {
				const disclaimerTextStatus = disclaimerText.hasClass('active');
				if (!disclaimerTextStatus) {
					disclaimerLink.attr(FixDisclaimer.ARIA_EXPANDED_ATTRIBUTE, 'true');
					disclaimerText.attr(FixDisclaimer.ARIA_HIDDEN_ATTRIBUTE, 'false');
				} else {
					disclaimerLink.attr(FixDisclaimer.ARIA_EXPANDED_ATTRIBUTE, 'false');
					disclaimerText.attr(FixDisclaimer.ARIA_HIDDEN_ATTRIBUTE, 'true');
				}
			});
		});
	}

	fixDisclaimerLinks() {
		const cleanLinkStyles = ' text-decoration: underline !important; font-weight: inherit !important; font-family:inherit !important; font-size: inherit !important; letter-spacing: inherit; background-image: none !important; letter-spacing: inherit !important; text-transform: inherit !important; border-bottom: none !important; box-shadow: none !important; line-height: inherit !important;';
		$(document).on('nfFormReady aiEnhancedFormUpdate', (e, layout) => {
			const currentForm = $(layout.$el[0]);
			currentForm.find('.fl-disclaimer a').each((i, link) => {
				const linkColor = this.maybeChangeLinkColor($(link));
				// @todo This part needs to be revisited when the disclaimer will be moved into the platform.
				$(link).css('cssText', `color: ${linkColor} !important; ${cleanLinkStyles}`);
				// A workaround for hovered links - hardcode the black color for the hovered links
				$(link).on('mouseenter', () => {
					$(link).css('cssText', `color: #000 !important; ${cleanLinkStyles}`);
				}).on('mouseleave', () => {
					$(link).css('cssText', `color: ${linkColor} !important; ${cleanLinkStyles}`);
				});
			});
		});
	}

	maybeChangeLinkColor($link) {
		const backgroundColor = $link.parent().css('background-color');
		const currentColor = $link.css('color');
		if (backgroundColor && currentColor) {
			const isAcceptableContrast = contrastRatio(currentColor, backgroundColor).passes.AA_normal;
			if (!isAcceptableContrast) {
				// Returns either white or black, depending on which provides better contrast with the background color
				return highestContrastColor(['#fff', '#000'], backgroundColor);
			}
		}
		return currentColor;
	}

	// AB#359170 Disclaimer Link Keyboard Accessibility Enhancements
	fixDisclaimerA11y() {
		jQuery(document).on('nfFormReady aiEnhancedFormUpdate', (e, layout) => {
			// Current NF Element
			const currentForm = $(layout.$el[0]);

			// Elements selected from current NF Element
			const disclaimerLink = currentForm.find('.form-disclaimer-trigger');
			const infoBox = currentForm.find('.fl-disclaimer');
			const closeBtn = currentForm.find('.fl-disclaimer__close');
			const nextLink = currentForm.find('.privacy-policy-link');

			// Proceed only if all elements are found
			const shouldProceed = window.siteFeatureToggles.ENABLE_AI_ENHANCED_FORM ?
				(disclaimerLink.length && infoBox.length && closeBtn.length)
				: (disclaimerLink.length && infoBox.length && closeBtn.length && nextLink.length);
			if (shouldProceed) {
				disclaimerLink.on('click', (event) => {
					event.preventDefault();
					this.toggleInfoBox(infoBox, disclaimerLink, closeBtn);
				});

				disclaimerLink.on('keydown', (event) => {
					if (event.key === 'Enter' || event.key === ' ') {
						event.preventDefault();
						this.toggleInfoBox(infoBox, disclaimerLink, closeBtn);
					} else if (event.key === 'Tab' && !event.shiftKey && infoBox.style.display === 'block') {
						event.preventDefault();
						closeBtn.focus();
					}
				});

				closeBtn.on('click', () => {
					this.closeInfoBox(infoBox, disclaimerLink);
				});

				closeBtn.on('keydown', (event) => {
					if (event.key === 'Enter' || event.key === ' ') {
						event.preventDefault();
						this.closeInfoBox(infoBox, disclaimerLink);
					} else if (event.key === 'Escape') {
						event.preventDefault();
						this.closeInfoBox(infoBox, disclaimerLink);
						disclaimerLink.focus();
					} else if (event.key === 'Tab' && !event.shiftKey) {
						event.preventDefault();
						this.closeInfoBox(infoBox, disclaimerLink);
						nextLink.focus();
					} else if (event.key === 'Tab' && event.shiftKey) {
						event.preventDefault();
						this.closeInfoBox(infoBox, disclaimerLink);
						disclaimerLink.focus();
					}
				});
			}
		});
	}

	toggleInfoBox(infoBox, disclaimerLink, closeBtn) {
		if (infoBox.css('display') === 'none' || infoBox.css('display') === '') {
			infoBox.css('display', 'block');
			disclaimerLink.attr('aria-expanded', 'true');
			infoBox.attr('aria-hidden', 'false');
			closeBtn.focus();
		} else {
			this.closeInfoBox(infoBox, disclaimerLink);
		}
	}

	closeInfoBox(infoBox, disclaimerLink) {
		infoBox.css('display', 'none');
		disclaimerLink.attr('aria-expanded', 'false');
		infoBox.attr('aria-hidden', 'true');
		disclaimerLink.focus();
	}
}



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/accessibility/nf/controllers/fix-disclaimer.js